import { createRoot } from 'react-dom/client';
import App from './App';
import './i18n/config';

const rootElement = document.getElementById('root');

if (rootElement) {
  createRoot(rootElement).render(<App />);
}
